"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaType = void 0;
/**
 * Enum value to specify the type of media for VivaAction.SelectMedia action.
 */
var MediaType;
(function (MediaType) {
    MediaType[MediaType["Image"] = 1] = "Image";
    MediaType[MediaType["Audio"] = 4] = "Audio";
    MediaType[MediaType["Document"] = 8] = "Document";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
//# sourceMappingURL=cardAction.js.map